import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/router-config';

export function AppRouter() {
  return <RouterProvider router={router} future={{ v7_startTransition: true }} />;
}
